(function () {
  "use strict";

  var SELECTOR = "[data-pdp-media-card-carousel]";

  function updateSoundButton(button, video) {
    if (!button || !video) return;

    var isMuted = video.muted;

    button.classList.toggle("is-muted", isMuted);
    button.setAttribute("aria-pressed", isMuted ? "false" : "true");
    button.setAttribute(
      "aria-label",
      isMuted ? "Unmute video" : "Mute video"
    );
  }

  function resetVideo(video) {
    if (!video) return;

    video.pause();
    video.controls = false;

    try {
      video.currentTime = 0;
    } catch (error) {
      // Video metadata may not be loaded yet.
    }

    video.muted = true;

    var media = video.closest(
      ".pdp-media-card-carousel__media--video"
    );

    var soundButton = media
      ? media.querySelector("[data-pdp-media-sound]")
      : null;

    if (media) {
      media.classList.remove("is-playing");
    }

    updateSoundButton(soundButton, video);
  }

  function pauseVideos(root, exceptVideo) {
    root.querySelectorAll("video").forEach(function (video) {
      if (video === exceptVideo) return;

      resetVideo(video);
    });
  }

  function playVideo(root, media, video, soundButton) {
    if (!video) return;

    pauseVideos(root, video);

    var playPromise = video.play();

    if (
      playPromise &&
      typeof playPromise.catch === "function"
    ) {
      playPromise.catch(function () {
        resetVideo(video);
      });
    }

    updateSoundButton(soundButton, video);
  }

  function bindVideos(root) {
    root
      .querySelectorAll(
        ".pdp-media-card-carousel__media--video"
      )
      .forEach(function (media) {
        if (media.dataset.videoBound === "true") return;

        var playButton = media.querySelector(
          "[data-pdp-media-play]"
        );

        var soundButton = media.querySelector(
          "[data-pdp-media-sound]"
        );

        var video = media.querySelector("video");

        if (!video) return;

        media.dataset.videoBound = "true";

        video.muted = true;
        video.controls = false;

        updateSoundButton(soundButton, video);

        if (playButton) {
          playButton.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();

            playVideo(root, media, video, soundButton);
          });
        }

        if (soundButton) {
          soundButton.addEventListener(
            "click",
            function (event) {
              event.preventDefault();
              event.stopPropagation();

              video.muted = !video.muted;

              updateSoundButton(soundButton, video);

              if (video.paused) {
                playVideo(root, media, video, soundButton);
              }
            }
          );
        }

        video.addEventListener("click", function () {
          if (!media.classList.contains("is-playing")) {
            playVideo(root, media, video, soundButton);
            return;
          }

          resetVideo(video);
        });

        video.addEventListener("play", function () {
          media.classList.add("is-playing");
        });

        video.addEventListener("pause", function () {
          if (!video.ended) {
            media.classList.remove("is-playing");
          }
        });

        video.addEventListener("volumechange", function () {
          updateSoundButton(soundButton, video);
        });

        video.addEventListener("ended", function () {
          resetVideo(video);
        });
      });
  }

  function init(root) {
    if (!root) return;

    if (root.dataset.pdpMediaInitialized === "true") {
      bindVideos(root);
      return;
    }

    if (typeof window.Swiper !== "function") return;

    var slider = root.querySelector(
      "[data-pdp-media-slider]"
    );

    if (!slider) return;

    var isVideo = root.dataset.cardType === "video";

    var previousButton = root.querySelector(
      "[data-pdp-media-prev]"
    );

    var nextButton = root.querySelector(
      "[data-pdp-media-next]"
    );

    var scrollbar = root.querySelector(
      "[data-pdp-media-scrollbar]"
    );

    var options = {
      slidesPerView: isVideo ? 1.45 : 1.2,
      spaceBetween: 7,
      speed: 450,
      watchOverflow: true,
      simulateTouch: true,
      grabCursor: true,

      mousewheel: {
        enabled: false,
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity: 1,
        thresholdDelta: 8
      },

      breakpoints: {
        769: {
          slidesPerView: 2.35,
          spaceBetween: 7,

          mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
            thresholdDelta: 8
          }
        },

        990: {
          slidesPerView: 3.8,
          spaceBetween: 7,

          mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
            thresholdDelta: 8
          }
        }
      },

      on: {
        slideChangeTransitionStart: function () {
          pauseVideos(root);
        }
      }
    };

    if (previousButton && nextButton) {
      options.navigation = {
        prevEl: previousButton,
        nextEl: nextButton
      };
    }

    if (scrollbar) {
      options.scrollbar = {
        el: scrollbar,
        draggable: true,
        hide: false,
        snapOnRelease: true
      };
    }

    root.pdpMediaSwiper = new window.Swiper(
      slider,
      options
    );

    root.dataset.pdpMediaInitialized = "true";

    bindVideos(root);
  }

  function initWithin(container) {
    var scope = container || document;

    if (
      scope.matches &&
      scope.matches(SELECTOR)
    ) {
      init(scope);
    }

    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  function destroyWithin(container) {
    var scope = container || document;
    var roots = [];

    if (scope.matches && scope.matches(SELECTOR)) roots.push(scope);
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      roots.push(el);
    });

    roots.forEach(function (root) {
      pauseVideos(root);

      if (root.pdpMediaSwiper) {
        root.pdpMediaSwiper.destroy(true, true);
        root.pdpMediaSwiper = null;
      }

      delete root.dataset.pdpMediaInitialized;
    });
  }

  function boot() {
    if (typeof window.Swiper !== "function") {
      window.addEventListener(
        "load",
        function () {
          initWithin(document);
        },
        {
          once: true
        }
      );

      return;
    }

    initWithin(document);
  }

  if (!window.PdpMediaCardCarousel) {
    window.PdpMediaCardCarousel = {
      initWithin: initWithin,
      destroyWithin: destroyWithin
    };

    document.addEventListener(
      "shopify:section:load",
      function (event) {
        initWithin(event.target);
      }
    );

    document.addEventListener(
      "shopify:section:unload",
      function (event) {
        var root = event.target.matches(SELECTOR)
          ? event.target
          : event.target.querySelector(SELECTOR);

        if (!root) return;

        pauseVideos(root);

        if (root.pdpMediaSwiper) {
          root.pdpMediaSwiper.destroy(true, true);
        }

        delete root.dataset.pdpMediaInitialized;
      }
    );

    document.addEventListener(
      "shopify:block:select",
      function (event) {
        var root = event.target.closest(SELECTOR);

        if (!root || !root.pdpMediaSwiper) return;

        var slide = root.querySelector(
          '[data-block-id="' +
            event.detail.blockId +
            '"]'
        );

        if (!slide) return;

        var slideIndex =
          Array.prototype.indexOf.call(
            slide.parentNode.children,
            slide
          );

        root.pdpMediaSwiper.slideTo(slideIndex);
      }
    );

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        boot,
        {
          once: true
        }
      );
    } else {
      boot();
    }
  } else {
    window.PdpMediaCardCarousel.initWithin(document);
  }
})();